<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "pompUsername":"aketest"
           },
            responseCode: {
                "data": {
                    "resources": [

                        {
                            "id": 20000000000,
                            "level": 1,
                            "name": "车场运营",
                            "orderVal": 2,
                            "permission": "PARK_MANAGE",
                            "type": 1,
                            "url": "#"
                        }
                    ]
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "根据POMP用户账号获取POMP资源权限",
                t_url: this.commonUrls.test+"getPompLoginUserInfoByUserFlag",
                p_url: this.commonUrls.prod+"getPompLoginUserInfoByUserFlag",
                precondition: "授权商拥有的车场权限必须全包含POMP账号的车场权限，否则返回“车场权限不足”",
                fitSystem: "POMP",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userFlag', info2: '是', info3: 'String', info4: 'pomp用户标识' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'name', info2: '是', info3: 'String', info4: '登录账号' },
                        { info1: 'nickname', info2: '否', info3: 'String', info4: '用户名' },
                        ]
                    },
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/other/getPompLoginUserInfoByUserFlag.vue